module.exports = __webpack_public_path__ + "assets/media/quote-icon.06cdc2d6.svg";


//////////////////
// WEBPACK FOOTER
// ./src/layouts/Testimonial/quote-icon.svg
// module id = 1986
// module chunks = 0